import Checkout from './Checkout';
import QuestionsPostOrder from './QuestionsPostOrder';
import Confirmation from './Confirmation';

export default Checkout;
export { QuestionsPostOrder, Confirmation };
